export default __webpack_public_path__ + "static/media/monero.45ccc83c.svg";